import Loading from "@components/loading/index.jsx";
import { isOlarkSupport, openOlark } from "@utils/olark";
import React, { useEffect, useState } from "react";

export default function Support() {
	const [showMask, setShowMask] = useState(false);

	const openChat = () => {
		if (isOlarkSupport()) {
			void openOlark();
			setShowMask(true);
			return;
		}

		if (window.ZENDESK_API_VERSION === 1) {
			if (window?.zE && window?.zE?.activate) {
				window?.zE?.activate();
				setShowMask(true);
			} else {
				setTimeout(openChat, 200);
			}
		} else if (window.ZENDESK_API_VERSION === 2) {
			window?.zE?.("messenger", "open");
			setShowMask(true);
		}
	};

	useEffect(() => {
		openChat();
	}, []);

	return (
		<>
			{window.TENANT !== "betto" && <Loading loading={true} />}

			{showMask && (
				<div
					style={{
						position: "fixed",
						right: "0px",
						width: "90px",
						height: "44px",
						backgroundColor: "rgb(237, 31, 36)",
						zIndex: 9999999,
					}}
				/>
			)}
		</>
	);
}
